/**
 * Utilities to annotate agent steps (assistant messages) so the UI can provide
 * step-based navigation / checkpointing.
 */
export function annotateAgentSteps(messages) {
  if (!Array.isArray(messages)) return [];
  let step = 0;
  return messages.map(m => {
    if (m?.role === 'assistant') {
      const txt = String(m.content || '');
      // Heuristic: treat an assistant message as a new step unless it is an Action_Response continuation
      if (!txt.includes('Action_Response for')) step += 1;
      return { ...m, _agentStep: step || undefined };
    }
    return m;
  });
}

export function getLastCommittedStep(messages) {
  if (!Array.isArray(messages)) return 0;
  let last = 0;
  for (const m of messages) {
    if (m?.role === 'assistant') {
      const txt = String(m.content || '');
      if (!txt.includes('Action_Response for')) last += 1;
    }
  }
  return last;
}
